export const APP_VERSION = '3.1.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};

export const API_URL = process.env.REACT_APP_API_SERVER;

export const LANAGUAGE_PAGES = 'LANAGUAGE_PAGES';
